var LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
var LOCAL_STORAGE_DELIMITER = ',';
var BUTTON_ACTIVE_CLASS = 'active';

var selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
};

document.addEventListener('DOMContentLoaded', function () {
  console.log("dom loaded");
  var buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);

  var grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
});

var setupGrid = function (grid) {
  console.log("setup grid");

  var wishlist = getWishlist();
  var requests = wishlist.map(function (handle) {
    var productTileTemplateUrl = '/products/' + handle + '?view=card';
    return fetch(productTileTemplateUrl).then(function (res) {
      return res.text();
    });
  });
  Promise.all(requests).then(function (responses) {
    setTimeout(function() {
  let wishlist_count_update_remove = jQuery(".wishlist-items div.shopify-section, ul.wishlist-items .shopify-section").length;
  jQuery("span.wishlist-count-update").text(wishlist_count_update_remove);
  console.log("wishlist remove count:" + wishlist_count_update_remove);
    if( wishlist_count_update_remove >= 1){
    jQuery(".wishlist-icon span.wishlist-count-update").show();
    jQuery(".wishlist-icon").addClass("fillsicon");
    }else{
    jQuery(".wishlist-icon span.wishlist-count-update").hide();
    jQuery(".wishlist-icon").removeClass("fillsicon");
    }
    }, 300);
    console.log("promise piush");
    var wishlistProductCards = responses.join('');
    grid.innerHTML = wishlistProductCards;
    var buttons = grid.querySelectorAll(selectors.button) || [];
    if (buttons.length) setupButtons(buttons);
  });
};

var setupButtons = function (buttons) {
  console.log("setupButtons");
  buttons.forEach(function (button) {
    var productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
    button.addEventListener('click', function () {
      console.log("here");
      updateWishlist(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
    });
  });
};

var getWishlist = function () {
  let wishlist_count_update_remove = jQuery(".wishlist-items div.shopify-section, ul.wishlist-items .shopify-section").length;
  jQuery("span.wishlist-count-update").text(wishlist_count_update_remove);
  console.log("wishlist remove count:" + wishlist_count_update_remove);
 if( wishlist_count_update_remove >= 1){
    jQuery(".wishlist-icon span.wishlist-count-update").show();
   jQuery(".wishlist-icon").addClass("fillsicon");
  }else{
    jQuery(".wishlist-icon span.wishlist-count-update").hide();
   jQuery(".wishlist-icon").removeClass("fillsicon");
  }
  console.log("getWishlist");

  var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

var setWishlist = function (array) {
  let wishlist_count_update_remove = jQuery(".wishlist-items div.shopify-section, ul.wishlist-items .shopify-section").length;
  jQuery("span.wishlist-count-update").text(wishlist_count_update_remove);
  console.log("wishlist remove count:" + wishlist_count_update_remove);
 if( wishlist_count_update_remove >= 1){
    jQuery(".wishlist-icon span.wishlist-count-update").show();
   jQuery(".wishlist-icon").addClass("fillsicon");
  }else{
    jQuery(".wishlist-icon span.wishlist-count-update").hide();
   jQuery(".wishlist-icon").removeClass("fillsicon");
  }
  console.log("setWishlist");

  var wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
  return wishlist;
};

var updateWishlist = function (handle) {
  let wishlist_count_update_remove = jQuery(".wishlist-items div.shopify-section, ul.wishlist-items .shopify-section").length;
  jQuery("span.wishlist-count-update").text(wishlist_count_update_remove);
  console.log(".wishlist remove count:" + wishlist_count_update_remove);
  
  if( wishlist_count_update_remove >= 1){
    jQuery(".wishlist-icon span.wishlist-count-update").show();
    jQuery(".wishlist-icon").addClass("fillsicon");
  }else{
    jQuery(".wishlist-icon span.wishlist-count-update").hide();
    jQuery(".wishlist-icon").removeClass("fillsicon");
  }
  console.log("updateWishlist");

  var wishlist = getWishlist();
  var indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
     
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

var wishlistContains = function (handle) {
  console.log("wishlistContains");

  var wishlist = getWishlist();
  return wishlist.indexOf(handle) !== -1;
};

var resetWishlist = function () {
  console.log("resetWishlist");

  return setWishlist([]);
};


function refreshWishList()
  {
  var buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  var grid = document.querySelector(selectors.grid) || false; 
  if (grid) setupGrid(grid);  
  }
$(document).on("click",".wishlistbtn, .wishlist-icon",function($)
               {
                 // console.log("out one");
                  refreshWishList();

});

$(document).on("click",".remove",function($)
               {  
                 
                 // updateWishlist($(this).attr("data-handle"));
                  refreshWishList();
                 
                 
});



//when remove active




$(document).ready(function($){
	$('.wishlist-drawer-header .js-menu__close, .js-menu__context_wishlist .product-showcase').click(function(){
		// location.reload();
      // refreshWishList();
      // updateWishlist($(this).attr("data-handle"));
      // updateWishlist(productHandle);
      // setupButtons();
      
      $("body").removeClass("popup");
      $(".js-menu__context_wishlist, .js-menu_wishlist").removeClass("js-menu__expanded_wish");
    });
});





$(document).ready(function($){
$(".wishlist-icon button[class]").click(function(){
  setTimeout(function () {
// $('.js-menu_wishlist').addClass('js-menu__expanded_wish'); 
// $('.js-menu__context_wishlist').addClass('js-menu__expanded_wish');
var wishlist_count_update_btn = $("ul.wishlist-items .shopify-section").length;
        $("span.wishlist-count-update").text(wishlist_count_update_btn);    
    }, 1500);
});
});


$(document).on("click", ".js-menu__open_wishlist", function(){
  var wishlist_count_update_headericon = $("ul.wishlist-items .shopify-section").length;
  $("span.wishlist-count-update").text(wishlist_count_update_headericon);
});
